/* @generated */

// src/assets/ui-icon/line/move.tsx
import * as React from "react";
var MoveLine = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props }, /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "m15.28 6.72-3.03-3.03-3.03 3.03 1.06 1.06 1.22-1.22V11H7.06l1.22-1.22-1.06-1.06-3.03 3.03 3.03 3.03 1.06-1.06-1.22-1.22h4.44v4.439l-1.219-1.22-1.06 1.062 3.03 3.03 3.03-3.03-1.06-1.061L13 16.94V12.5h4.44l-1.22 1.22 1.061 1.06 3.03-3.03-3.03-3.03-1.06 1.06L17.44 11H13V6.56l1.22 1.22 1.06-1.06Z",
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke"
  }
));
export {
  MoveLine
};
